/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from "react";

import { withStyles, createMuiTheme, ThemeProvider } from "@material-ui/core";

import {
  Tabs,
  Tab,
  Typography,
  Divider,
  Tooltip,
  Button,
  Grid,
  IconButton,
  Paper,
  Zoom,
  Slider,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  FormControl,
  FormControlLabel,
  Checkbox,
  TextField,
  InputAdornment,
  Switch,
  Select,
  InputLabel,
  MenuItem
} from "@material-ui/core";
import {
  Add,
  CheckCircleOutlined,
  Clear,
  HighlightOff,
} from "@material-ui/icons";

import ChipInput from 'material-ui-chip-input';
import { v4 as uuidv4 } from 'uuid';

import FDropDown from "../../../fluid/Elements/Inputs/FDropDown";
const clone = require("rfdc")();

const styles = (theme) => ({
  insetTab: {
    borderRight: `1px solid ${theme.palette.divider}`,
    width: "10%",
  },
});


const blue_theme = createMuiTheme({
  palette: {
    primary: {
      main: "#2296f3",
    },
    secondary: {
      main: "#f50157",
    },
  },
});

class OpsConfig extends Component {
  state = {
    insetTabValue: 0,
    removing_index: null,
    reset_dialog: false,
    submit_dialog: false,
    inset_content_height: null,
    val_status: null,
  };

  insetHeading = React.createRef();
  fieldHeading = React.createRef();

  componentWillMount () {
    console.log("Ops Config : ", this.props.config)
  }

  componentDidMount() {
    if (this.props.validation_config.field_config_required === true) {
      let inset_content_height = this.props.content_height - this.insetHeading.current.clientHeight - this.fieldHeading.current.clientHeight;
      this.setState({
        ...this.state,
        inset_content_height: inset_content_height,
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.config !== this.props.config) {
      console.log("Component Updated with Props :", this.props.config);
    }
  }

  handleInsetTabChange = (event, value) => {
    this.setState({
      ...this.state,
      insetTabValue: value,
    });
  };

  renderInsetTabs = (insetTabValue) => {
    const { classes } = this.props;

    if (insetTabValue === 1) {
      if (this.props.validation_config.ops_config_required === false) {
        return this.renderSkipBlock();
      } else {
        return this.renderOpsTab(this.props.config);
      }
    } else if (insetTabValue === 0) {
      if (this.props.validation_config.field_config_required === false) {
        return this.renderSkipBlock();
      } else {
        return this.renderFieldsTab(this.props.config);
      }
    }
  };

  disableSubmit = () => {
    if (this.props.config.edit === false) {
      return true;
    } else {
      let field_error_index = this.props.config.fields.findIndex(
        (field) => field.error === true
      );

      if (field_error_index === -1) {
        return false;
      } else {
        return true;
      }
    }
  };

  renderEditAndReset = (ops_name) => {
    if (this.props.config.edit === false) {
      return (
        <Tooltip title="Edit Configuration">
          <Button
            style={{ marginRight: "10px" }}
            size="small"
            variant="contained"
            color="secondary"
            onClick={() => this.props.edit_ops(ops_name)}
          >
            Edit
          </Button>
        </Tooltip>
      );
    } else {
      return (
        <Tooltip title="Reset Configuration">
          <Button
            style={{ marginRight: "10px" }}
            size="small"
            variant="contained"
            color="secondary"
            disabled={this.props.config.fields.length > 0 ? false : true}
            onClick={() =>
              this.setState({
                ...this.state,
                reset_dialog: true,
                cur_ops_name: this.props.config.operation,
              })
            }
          >
            Reset
          </Button>
        </Tooltip>
      );
    }
  };

  renderSubmitMessage = (config) => {
    if (config.submit_error === false && config.submit_time !== "") {
      let time_stamp = new Date(config.submit_time);
      console.log("Time Stamp : ", time_stamp);
      return (
        <Typography style={{ color: "#05AF1A" }} variant="subtitle">
          <em>{"Last Succesful Submit : " + time_stamp}</em>
        </Typography>
      );
    } else if (config.submit_error === true) {
      return (
        <Typography style={{ color: "#f44336" }} variant="caption">
          <em>{"Error : " + config.error_message}</em>
        </Typography>
      );
    }
  };

  renderFieldsTab = (config) => {
    return (
      <div
        style={{ maxHeight: "100%", display: "flex", flexDirection: "column" }}
      >
        <div ref = {this.fieldHeading} style = {{width : '100%', padding : '5px', borderBottom : '1px solid rgba(0,0,0,0.12)', backgroundColor : '#F0F0F0'}}>
          <Typography variant = 'subtitle2' color = 'primary'>Field Configuration</Typography>
        </div>
        <div
          style={{
            height: this.state.inset_content_height,
            maxHeight: this.state.inset_content_height,
            flexGrow: 1,
            overflow: "scroll",
            padding : '5px',
            backgroundColor : '#FAFBFC'
          }}
        >
          <Grid
            container
            xs={12}
            spacing={1}
            direction="row"
            wrap="wrap"
            alignItems="start"
          >
            {this.generateFields(this.props.config.fields)}
          </Grid>
        </div>
      </div>
    );
  };

  renderFieldRoles = (crntField, index, field_roles) => {
    return field_roles.map((fieldRoleObj) => {
      return (
        <>
          <Paper
            variant="outlined"
            style={{
              width : '47%',
              height: "60px",
              margin : '5px',
              padding : '10px',
              display: "flex",
              alignItems: "center",
            }}
          >
            <FormControl component={`${fieldRoleObj.value}-check-box`}>
              <FormControlLabel
                // style={{ width: "100%" }}
                disabled={!this.props.config.edit}
                control={
                  <Checkbox
                    size="small"
                    checked={crntField.roles.includes(fieldRoleObj.value)}
                    onChange={(event) =>
                      this.handleFieldRoleChange(
                        fieldRoleObj.value,
                        event.target.checked,
                        index
                      )
                    }
                    name={fieldRoleObj.value}
                    color="secondary"
                  />
                }
                label={fieldRoleObj.label}
              />
            </FormControl>
          </Paper>
          {fieldRoleObj.value === "Predictor" &&
          crntField.roles.includes("Predictor") &&
          this.props.config.operation !== "TopicModel" ? (
            <Paper
              variant="outlined"
              style={{
                width: "calc(50% - 7.5px)",
                height: "60px",
                margin: "5px 0 0 5px",
                padding: "5px 10px",
              }}
            >
              {this.renderSlider(crntField, index)}
            </Paper>
          ) : null}
        </>
      );
    });
  };

  generateFields = (ops_fields) => {
    let fields = ops_fields.map((field, index) => {
      return (
        <Grid key={field.id} xs={4} item spacing={0}>
          <Paper
            variant={this.props.config.edit === true ? "elevated" : "outlined"}
            elevation={2}
            style={{
              margin: "5px",
              padding: "10px",
              backgroundColor: this.props.config.edit === true ? "#FFFFFF" : "#F0F0F0"
            }}
          >
            <Typography
              color={
                this.props.config.edit === true
                  ? "textPrimary"
                  : "textSecondary"
              }
              style={{ width: "100%", fontSize : '15px' }}
              variant="subtitle2"
            >
              {field.name}
            </Typography>
            <Typography
              color="textSecondary"
              variant="caption"
            >
              World View Field
            </Typography>
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap"
              }}
            >
              {this.renderFieldRoles(field, index, this.props.field_roles)}
            </div>
          </Paper>
        </Grid>
      );
    });

    return fields;
  };

  renderSlider = (field, index) => {
    let value = field.weight;

    if (field.roles.includes("Predictor")) {
      return (
        <Fragment>
          <Typography
            color={
              this.props.config.edit === true ? "textPrimary" : "textSecondary"
            }
          >
            Weight: {value < 0 ? null : value}
          </Typography>
          <Slider
            value={value}
            onChange={(event, value) =>
              this.handleWeightConfigFieldChange("weight", value, index)
            }
            // marks = {[{value: 0, label: '0.00'}, {value: 1, label : '1.00'}]}
            min={0}
            max={1}
            step={0.01}
            valueLabelDisplay="auto"
            disabled={!this.props.config.edit}
          />
        </Fragment>
      );
    }
  };

  findSimlarFieldWithError = (name, role) => {
    let config = { ...this.props.config };
  };

  handleFieldRoleChange = (role, isAdded, index) => {
    let config = { ...this.props.config };
    // let similar_field_index;
    // if (key[0] === "role") {
    //   similar_field_index = this.props.config.fields.findIndex(
    //     (field) =>
    //       field.name === config.fields[index].name && field.role === value
    //   );
    // } else {
    //   similar_field_index = config.fields.findIndex(
    //     (field) =>
    //       field.name === value && field.role === config.fields[index].role
    //   );
    // }

    // if (similar_field_index === -1) {
    if (isAdded) {
      config.fields[index]["roles"] = [...config.fields[index]["roles"], role];
      if (role === "Predictor") {
        config.fields[index].weight = 0;
      }

      config.fields[index].error = false;
      config.fields[index].error_message = "";
    } else {
      config.fields[index]["roles"] = config.fields[index]["roles"].filter(
        (roleName) => roleName !== role
      );
      if (role === "Predictor") {
        config.fields[index].weight = -1;
      }

      config.fields[index].error = false;
      config.fields[index].error_message = "";
    }

    // } else {
    //   config.fields[index][key[0]] = value;
    //   config.fields[index].weight = value !== "Predictor" ? -1 : 0;
    //   config.fields[index].error = true;
    //   config.fields[index].error_message =
    //     "The same field with this role exists.";
    // }
    this.props.update_config(this.props.config.operation, config);
  };

  handleWeightConfigFieldChange = (key, value, index) => {
    let config = { ...this.props.config };
    if (value <= this.findSliderValueRestriction(index)) {
      config.fields[index][key] = value;
    }

    this.props.update_config(this.props.config.operation, config);
  };

  findSliderValueRestriction = (index) => {
    let restricted_value = 1.0;
    let current_total = 0.0;

    let fields = this.props.config.fields;
    fields.map((field, i) => {
      if (index !== i) {
        if (field.weight !== -1) {
          current_total = current_total + field.weight;
        }
      }
    });

    restricted_value = restricted_value - current_total;
    return Math.round((restricted_value + Number.EPSILON) * 100) / 100;
  };

  addField = () => {
    let config = { ...this.props.config };
    let new_id = uuidv4()
    config.fields.push({
      id: new_id,
      name: "",
      role: "",
      weight: -1,
      error: false,
      error_message: "",
    });

    this.props.update_config(this.props.config.operation, config);
  };

  removeField = (id) => {
    let config = { ...this.props.config };
    let delete_index = config.fields.findIndex((field) => field.id === id);
    config.fields.splice(delete_index, 1);

    this.props.update_config(this.props.config.operation, config);
  };

  removeCurField = (index) => {
    this.setState({ ...this.state, removing_index: index });
  };

  resetConfig = () => {
    let config = { ...this.props.config };
    config.fields.map(field => {
      field.roles = []
      field.weight = -1
    })
    console.log("Reset Config : ", config);
    this.setState({ reset_dialog: false }, () => this.props.update_config(this.props.config.operation, config));
  };

  renderOpsTab = (config) => {
    return (
      <div style = {{
        width : '100%',
        height : '100%'
      }}>
        <div style = {{width : '100%', padding : '5px', borderBottom : '1px solid rgba(0,0,0,0.12)', backgroundColor : '#F0F0F0'}}>
          <Typography variant = 'subtitle2' color = 'primary'>Operation Parameters</Typography>
        </div>
        <div
          style={{
            height: this.state.inset_content_height,
            maxHeight: this.state.inset_content_height,
            flexGrow: 1,
            overflow: "scroll",
            padding : '5px',
            backgroundColor : '#FAFBFC'
          }}
        >
          {this.renderOpsFields(config)}
        </div>
      </div>
    )
  };

  renderOpsFields = (config) => {
    let op_params = this.props.ops.map(op_param => {
      if (op_param.type === 'boolean') {
        return (
          <Paper elevation = {2} variant = 'outlined' style = {{margin : '3px', padding : '10px', backgroundColor: this.props.config.edit === true ? "#FFFFFF" : "#F0F0F0"}}>
            <FormControlLabel
              control= {
                <Switch
                  checked = {this.props.config.ops_params[op_param.field]} 
                  color = 'primary'
                  onChange={(event) => {
                    let new_config = clone(config)
                    new_config.ops_params[op_param.field] = event.target.checked
                    this.props.update_config(new_config.operation, new_config)
                  }} 
                  name = {op_param.name} 
                />}
              disabled={!this.props.config.edit}
              label = {op_param.name}
              labelPlacement = 'start'
            />
          </Paper>
        )
      } else if (op_param.type === 'slider') {
        return (
          <Paper elevation = {2} variant = 'outlined' style = {{margin : '3px', padding : '10px', backgroundColor: this.props.config.edit === true ? "#FFFFFF" : "#F0F0F0"}}>
            <Typography variant = 'body2'>{op_param.name}</Typography>
            <Slider
              value={this.props.config.ops_params[op_param.field]}
              onChange={(event, value) => {
                let new_config = clone(config)
                  new_config.ops_params[op_param.field] = value
                  this.props.update_config(new_config.operation, new_config)
                }
              }
              // marks = {[{value: 0, label: '0.00'}, {value: 1, label : '1.00'}]}
              min={0}
              max={1}
              step={op_param.step_size}
              valueLabelDisplay="auto"
              disabled={!this.props.config.edit}
              marks = {[
                {
                  value: 0.0,
                  label : "0.0"
                },{
                  value: 1.0,
                  label : "1.0"
                }
              ]}
            />
          </Paper>
        )
      } else if (op_param.type === 'text_list') {
        return (
          <Paper elevation = {2} variant = 'outlined' style = {{margin : '3px', padding : '10px', backgroundColor: this.props.config.edit === true ? "#FFFFFF" : "#F0F0F0"}}>
            <FormControl
                    style = {{width : '100%'}}
                    variant = 'standard' 
                    margin = 'dense'
                    error = {this.state.error}
                    disabled = {this.props.disabled}
                >
                    {/* <Typography>{ this.props.instance.name } </Typography> */}
                    <ChipInput 
                        defaultValue={this.props.config.ops_params[op_param.field]}
                        onChange={(chips) => {
                          let new_config = clone(config)
                          new_config.ops_params[op_param.field] = chips
                          this.props.update_config(new_config.operation, new_config)
                        }}
                        onDelete={(chip, index) => {
                          let new_config = clone(config)
                          new_config.ops_params[op_param.field] = new_config.ops_params[op_param.field].filter(c => c !== chip)
                          this.props.update_config(new_config.operation, new_config)
                        }}
                        fullWidth
                        label = {op_param.name}
                        size = 'small'
                    />  
                    
                </FormControl>
          </Paper>
        )
      } else if (op_param.type === 'select') {
        return (
          <Paper elevation = {2} variant = 'outlined' style = {{margin : '3px', padding : '10px', backgroundColor: this.props.config.edit === true ? "#FFFFFF" : "#F0F0F0"}}>
            <FormControl 
                style = {{width : '100%'}}
                variant = 'standard' 
                margin = 'dense'
            >
                <InputLabel>{op_param.name}</InputLabel>
                <Select
                    value = {this.props.config.ops_params[op_param.field]}
                    onChange = {(event) => {
                      let new_config = clone(config)
                      new_config.ops_params[op_param.field] = event.target.value
                      this.props.update_config(new_config.operation, new_config)
                    }}
                    label = {op_param.name}
                >     
                    {!op_param.field_required && <MenuItem value={null}>
                        <em>--None--</em>
                    </MenuItem>}
                    {op_param.options.map(option => {
                        return (
                            <MenuItem value = {option}>{option}</MenuItem>
                        )
                    })}
                </Select>
            </FormControl>
          </Paper>
        )
      } else {
        return (
          <Paper elevation = {2} variant = 'outlined' style = {{margin : '3px', padding : '10px', backgroundColor: this.props.config.edit === true ? "#FFFFFF" : "#F0F0F0"}}>
            <TextField
              style = {{width : '100%'}}
              label = {op_param.name}
              type = {op_param.type}
              defaultValue = {op_param.default}
              disabled={!this.props.config.edit}
              value = {this.props.config.ops_params[op_param.field]}
              onChange = {(event) => {
                let new_config = clone(config)
                new_config.ops_params[op_param.field] = event.target.value
                this.props.update_config(new_config.operation, new_config)
              }}
              InputProps = {op_param.adornment !== null ? {
                startAdornment: op_param.adornment.start !== null ? <InputAdornment position="start">{op_param.adornment.start}</InputAdornment> : null,
                endAdornment: op_param.adornment.end !== null ? <InputAdornment position="start">{op_param.adornment.end}</InputAdornment> : null,
              } : null}
            />
          </Paper>
        )
      }
    })

    return op_params
  }

  renderResetConfirmation = () => {
    return (
      <ThemeProvider theme={blue_theme}>
        <Dialog open={this.state.reset_dialog}>
          <DialogTitle id="alert-dialog-title">
            Reset Field Configuration ?
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              All field configurations will be removed. This action cannot be reversed.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button color="secondary" onClick={() => this.resetConfig()}>
              Reset
            </Button>
            <Button
              color="primary"
              autoFocus
              onClick={() =>
                this.setState({ ...this.state, reset_dialog: false })
              }
            >
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      </ThemeProvider>
    );
  };

  renderSubmitConfirmation = () => {
    return (
      <ThemeProvider theme={blue_theme}>
        <Dialog open={this.state.submit_dialog}>
          <DialogTitle id="alert-dialog-title">Submit Confirmation</DialogTitle>
          <DialogContent>
            <div style={{ marginTop: "10px", marginBottom: "30px" }}>
              <Typography variant="button">Validations Passed</Typography>
              <Divider style={{ marginTop: "5px", marginBottom: "5px" }} />
              {this.renderValidations()}
            </div>
            <DialogContentText id="alert-dialog-description">
              {this.renderValidationText()}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              color="secondary"
              onClick={() =>
                this.setState({ ...this.state, submit_dialog: false })
              }
            >
              Cancel
            </Button>
            <Button
              color="primary"
              disabled={
                this.state.val_status !== null &&
                this.state.val_status.filter((val) => val === false).length ===
                  0
                  ? false
                  : true
              }
              onClick={() => {
                this.props.submit_config(this.props.config.operation);
                this.setState({ ...this.state, submit_dialog: false });
              }}
            >
              Submit
            </Button>
          </DialogActions>
        </Dialog>
      </ThemeProvider>
    );
  };

  renderValidationText = () => {
    let text;
    if (this.state.val_status !== null) {
      let val_status = this.state.val_status.filter((val) => val === false);

      if (val_status.length === 0) {
        text =
          "All Validations have passed! Proceeding to Submit will overwrite any previous configuration. Would you like to submit?";
      } else {
        text = "Please pass all validations before submitting the config.";
      }
    }

    return text;
  };

  renderValidationLabel = (index) => {
    if (index === 0) {
      return (
        <Typography variant="body2">
          Field Names and Field Roles cannot be empty
        </Typography>
      );
    } else if (index === 1) {
      return (
        <Typography variant="body2">Should contain atleast 1 field</Typography>
      );
    } else if (index === 2) {
      return (
        <Typography variant="body2">
          Should contain fields with Roles:{" "}
          <em>
            {this.props.validation_config.should_contain_type.join(" , ")}
          </em>
        </Typography>
      );
    } else if (index === 3) {
      return (
        <Typography variant="body2">
          Total Weight of Predictor Fields should be equal to 1
        </Typography>
      );
    }
  };

  renderValidations = () => {
    let validations;
    if (this.state.val_status !== null) {
      validations = this.state.val_status.map((val, i) => {
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              marginBottom: "5px",
            }}
          >
            {val === true ? (
              <CheckCircleOutlined
                fontSize="small"
                style={{ color: "#4caf50", marginRight: "10px" }}
              />
            ) : (
              <HighlightOff
                fontSize="small"
                style={{ color: "#f44336", marginRight: "10px" }}
              />
            )}
            {this.renderValidationLabel(i)}
          </div>
        );
      });
    } else {
      validations = "Nothing to validate.";
    }

    return validations;
  };

  validateAndSubmit = () => {
    let val_status = this.validate(this.props.validation_config);
    this.setState({
      ...this.state,
      submit_dialog: true,
      val_status: val_status,
    });
  };

  validate = (val_config) => {
    if (val_config.validation_required === true) {
      let val_status = [false, false, false];

      let val = val_config;

      if (val.empty_fields_allowed === false) {
        let status = this.emptyFieldCheck(this.props.config.fields);
        val_status[0] = status;
      } else {
        val_status[0] = true;
      }

      if (val.zero_fields_allowed === false) {
        let zero_fields_allowed = this.fieldLengthValidation(
          this.props.config.fields
        );
        val_status[1] = zero_fields_allowed;
      } else {
        val_status[1] = true;
      }

      if (val.should_contain_type.length > 0) {
        let should_contain_type = this.fieldTypeValidation(
          this.props.config.fields,
          val.should_contain_type
        );
        val_status[2] = should_contain_type;
      } else {
        val_status[2] = true;
      }

      if (val.weight_validation === true) {
        let weight_validation = this.fieldWeightValidation(
          this.props.config.fields
        );
        val_status[3] = weight_validation;
      } else {
        val_status[3] = true;
      }

      return val_status;
    } else {
      return null;
    }
  };

  emptyFieldCheck = (fields) => {
    let empty_field_index = fields.findIndex((field) => field.name === "");
    let empty_role_index = fields.findIndex((field) => field.role === "");

    if (fields.length === 0) {
      return false;
    }
    if (empty_field_index === -1 && empty_role_index) {
      return true;
    } else {
      return false;
    }
  };

  fieldLengthValidation = (fields) => {
    if (fields.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  fieldTypeValidation = (fields, types) => {
    let types_present = types.map((type) => {
      let field_index = fields.findIndex((field) => field.roles.includes(type));

      if (field_index !== -1) {
        return true;
      } else {
        return false;
      }
    });

    let all_types_present = types_present.filter((type) => type === false);

    if (all_types_present.length === 0) {
      return true;
    } else {
      return false;
    }
  };

  fieldWeightValidation = (fields) => {
    let total_weight = 0;

    fields.map((field) => {
      if (field.weight !== -1) {
        total_weight = total_weight + field.weight;
      }
    });

    if (total_weight === 1.0) {
      return true;
    } else {
      return false;
    }
  };

  renderContent = () => {
    if (
      this.props.validation_config.field_config_required === false &&
      this.props.validation_config.ops_config_required === false
    ) {
      return this.renderSkipBlock();
    } else {
      return this.renderConfigEditor();
    }
  };

  renderSkipBlock = () => {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography variant="body2">
          No Config Parameters for this operation.
        </Typography>
      </div>
    );
  };

  // renderConfigEditor = () => {
  //   const { classes } = this.props;
  //   return (
  //     <ThemeProvider theme={blue_theme}>
  //       <div className={classes.insetTab}>
  //         <Tabs
  //           orientation="vertical"
  //           value={this.state.insetTabValue}
  //           onChange={this.handleInsetTabChange}
  //           indicatorColor="primary"
  //           textColor="primary"
  //           centered
  //         >
  //           <Tab label="Fields" />
  //           <Tab label="Operation" />
  //         </Tabs>
  //       </div>
  //       <div style={{ padding: "5px", flexGrow: 1 }}>
  //         {this.renderInsetTabs(this.state.insetTabValue)}
  //       </div>
  //     </ThemeProvider>
  //   );
  // };

  renderConfigEditor = () => {
    const { classes } = this.props;
    return (
      <ThemeProvider theme={blue_theme}>
        <div style = {{width : '100%', height : '100%'}}>
          {this.renderConfigToolBar(this.props.config)}
          <div style = {{width : '100%', display : 'flex', flexDirection : 'row'}}>
            <div style = {{width : '75%',borderRight : '1px solid rgba(0,0,0,0.25)'}}>
              {this.renderInsetTabs(0)}
            </div>
            <div style = {{width : '25%'}}>
              {this.renderInsetTabs(1)}
            </div>
          </div>
        </div>
      </ThemeProvider>
    );
  };

  renderConfigToolBar = (config) => {
    return (
      <div
        ref={this.insetHeading}
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          padding : '5px',
          borderBottom : '1px solid rgba(0,0,0,0.12)'
        }}
      >
        <div
          style={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <Typography style={{ marginRight: "10px" }} variant="button">
            Configuration
          </Typography>
          {this.renderSubmitMessage(config)}
        </div>
        {this.renderEditAndReset(config.operation)}
        <Tooltip title="Submit Configuration">
          <Button
            color="primary"
            variant="contained"
            size="small"
            disabled={this.disableSubmit()}
            onClick={this.validateAndSubmit}
          >
            Submit
          </Button>
        </Tooltip>
      </div>
    )
  }

  render() {
    const { classes } = this.props;

    return (
      <Fragment>
        <div
          style={{
            width: "100%",
            height: this.props.content_height,
            display: "flex",
            flexDirection: "row",
          }}
        >
          {this.renderContent()}
        </div>
        {this.renderResetConfirmation()}
        {this.renderSubmitConfirmation()}
      </Fragment>
    );
  }
}

export default withStyles(styles)(OpsConfig);
